import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {IconButton} from "@mui/material";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import CheckIcon from "@mui/icons-material/Check";
import StyledTooltip from "../../components/tooltips/StyledTooltip";
import {ALERT} from "../../resources/environment";

const COPIED_DURATION_MS = 2000;

const MaestroSessionId = ({sessionId}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return;
    }
    const timeout = setTimeout(() => setCopied(false), COPIED_DURATION_MS);
    return () => clearTimeout(timeout);
  }, [copied]);

  if (!sessionId) {
    return null;
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(sessionId);
      setCopied(true);
    } catch {
      ALERT.error("Could not copy the session ID");
    }
  };

  return (
    <StyledTooltip title={copied ? "Copied" : "Copy session ID"}>
      <IconButton
        id="rex-ai-maestro-session-id"
        size="small"
        onClick={handleCopy}
        aria-label="Copy session ID"
      >
        {copied ?
          <CheckIcon fontSize="small" color="success" /> :
          <FingerprintIcon fontSize="small" />}
      </IconButton>
    </StyledTooltip>
  );
};

MaestroSessionId.propTypes = {
  sessionId: PropTypes.string,
};

export default MaestroSessionId;
